








import Vue from "vue";
import Component from "vue-class-component";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "TabsOffice",
})
export default class TabsOffice extends Vue {}
